import { compose } from 'recompose';

import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import TopProducts from './TopProducts';

const enhance = compose(withDeviceInfo);

export default enhance(TopProducts);
